<template>
    <div class="col-12">
        <div class="input-group mb-3">
            <input aria-describedby="basic-addon1" aria-label=""
                   class="form-control col-form-label-lg"
                   name="search" placeholder="Rechercher" type="text" v-model="query" v-on:input="search(false)">
            <div class="input-group-append">
                <button class="btn btn-primary" type="button" v-on:click="search(false)">Rechercher
                </button>
                <button class="btn btn-success" type="button" v-on:click="export_csv()"><i
                        class="fas fa-file-excel"></i> Export Excel
                </button>
            </div>
        </div>
        <small class="form-text text-muted">
            Nombre de résultats affichés : <i class='fas fa-circle-notch fa-spin' v-if="loading"></i> <span
                v-if="!loading">{{ (response['total'] > 0) ? '1 - ' + response['to'] +
            '(total: ' + response['total'] + ')' : '0'}}</span>
        </small>

        <div class="row mt-3">
            <div class="col-sm-12 col-md">
                <div class="form-group row">
                    <label class="col-1 col-form-label" for="start_date">du</label>
                    <input :disabled="loading" class="form-control form-control-sm col-11"
                           id="start_date" name="start_date" type="date" v-model="start_date"
                           v-on:change="search(false)"/>
                </div>
            </div>
            <div class="col">
                <div class="form-group row">
                    <label class="col-1 col-form-label" for="end_date">au</label>
                    <input :disabled="loading" class="form-control form-control-sm col-11"
                           id="end_date" name="end_date" type="date" v-model="end_date"
                           v-on:change="search(false)"/>
                </div>
            </div>
        </div>
        <div class="row mt-5">
            <div class="col-12">
                <div class="table-responsive">
                    <table class="table table-hover">
                        <thead>
                        <tr>
                            <th v-for="(column, index) in columns" v-on:click="sortBy(index)">
                                <span style="cursor: pointer;">{{ column['name'] }}</span>
                                <span v-if="column['orderable']">
                            <i class="fas fa-arrow-down fa-sm"
                               v-bind:class="{'text-danger': sortCell === index && column['sortDirection'] === 1}"></i>
                            <i class="fas fa-arrow-up fa-sm"
                               v-bind:class="{'text-danger': sortCell === index && column['sortDirection'] === -1}"></i>

                        </span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="loading && page === 1">
                            <td colspan="7"><i class="fas fa-circle-notch fa-spin"></i> Chargement des données en cours
                            </td>
                        </tr>
                        <tr v-if="data.length === 0 && loading === false">
                            <td colspan="7">Aucun lot ne correspond à vos critères de recherche.</td>
                        </tr>
                        <tr v-for="entry in filteredResults" v-if="!loading || page > 1">
                            <td>
                                <div class="btn-group"
                                     v-if="entry['withdraw_at'] === null && entry['setup_at'] !== null">
                                    <button class="btn btn-danger btn-sm" type="button" v-on:click="updateBatch(entry)">
                                        Fermer
                                    </button>
                                    <button aria-expanded="false"
                                            aria-haspopup="true"
                                            class="btn btn-danger btn-sm dropdown-toggle dropdown-toggle-split"
                                            data-toggle="dropdown" type="button">
                                        <span class="sr-only">donner les détails</span>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" v-on:click="updateBatch(entry)">Fermer maintenant</a>
                                        <a class="dropdown-item" data-target="#detailsModal"
                                           data-toggle="modal" v-on:click="openDetails(entry)">Préciser la date</a>
                                    </div>
                                </div>
                                <div class="btn-group" v-if="entry['setup_at'] === null">
                                    <button class="btn btn-primary btn-sm" type="button"
                                            v-on:click="updateBatch(entry)">
                                        Ouvrir
                                    </button>
                                    <button aria-expanded="false"
                                            aria-haspopup="true"
                                            class="btn btn-primary btn-sm dropdown-toggle dropdown-toggle-split"
                                            data-toggle="dropdown" type="button">
                                        <span class="sr-only">donner les détails</span>
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" v-on:click="updateBatch(entry)">Ouvrir maintenant</a>
                                        <a class="dropdown-item" data-target="#detailsModal"
                                           data-toggle="modal" v-on:click="openDetails(entry)">Préciser la date</a>
                                    </div>
                                </div>
                            </td>
                            <td>{{ entry['batch_number']}}</td>
                            <td>{{ entry['provider']}}</td>
                            <td>{{ entry['setup_at']| moment('DD/MM/YYYY HH:mm')}}</td>
                            <td>{{ entry['setup_by_name']}}</td>
                            <td>{{ entry['withdraw_at']| moment('DD/MM/YYYY HH:mm')}}</td>
                            <td>{{ entry['withdraw_by_name']}}</td>
                        </tr>
                        <tr v-if="!loading && data.length !== 0 && response['last_page'] > page">
                            <td colspan="6" id="loadMore" v-on:click="loadMore">Charger plus ...</td>
                        </tr>
                        <tr v-if="loading && data.length !== 0 && response['last_page'] > page">
                            <td colspan="6"><i class="fas fa-circle-notch fa-spin"></i> Chargement des prochains
                                résultats en cours
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <!-- Modal -->
        <div aria-hidden="true" aria-labelledby="detailsModalTitle" class="modal fade" id="detailsModal"
             role="dialog" tabindex="-1">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="batch_selected !== undefined">
                    <div class="modal-header">
                        <h5 class="modal-title" id="detailsModalTitle">Détail du lot</h5>
                    </div>
                    <div class="modal-body">
                        <div class="form-group row" v-if="batch_selected.setup_at == null">
                            <label class="col-sm-3 col-form-label"
                                   for="setup_at">Ouvert le</label>
                            <div class="col-sm-9">
                                <VueCtkDateTimePicker :first-day-of-week="1"
                                                      :format="'YYYY-MM-DD hh:mm'" :id="'setup_at'"
                                                      :label="'Date'" :locale="'fr'"
                                                      :now="'Maintenant'"
                                                      :output-format="'YYYY-MM-DDThh:mm:ssZ'"
                                                      v-model="date_t"/>
                            </div>
                        </div>
                        <div class="form-group row" v-if="batch_selected.withdraw_at == null">
                            <label class="col-sm-3 col-form-label"
                                   for="withdraw_at">Fermé le</label>
                            <div class="col-sm-9">
                                <VueCtkDateTimePicker :first-day-of-week="1"
                                                      :format="'YYYY-MM-DD hh:mm'" :id="'withdraw_at'"
                                                      :label="'Date'" :locale="'fr'"
                                                      :now="'Maintenant'"
                                                      :output-format="'YYYY-MM-DDThh:mm:ssZ'"
                                                      v-model="date_t"/>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-secondary" data-dismiss="modal" type="button">Annuler</button>
                        <button class="btn btn-primary" data-dismiss="modal" type="button"
                                v-on:click="updateBatch(batch_selected, true)">Enregistrer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['equipment_id'],
        data: function () {
            return {
                batch_selected: undefined,
                date_t: undefined,
                page: 1,
                response: [],
                sortCell: '',
                loading: true,
                query: '',
                data: [],
                equipments: [],
                start_date: '',
                end_date: '',
                columns: {
                    'details': {
                        name: 'Actions',
                        db_name: '',
                        orderable: false,
                        sortDirection: 1,
                        type: ''
                    },
                    'batch_number': {
                        name: 'Numéro de lot',
                        db_name: 'batch_number',
                        orderable: false,
                        sortDirection: 1,
                        type: 'text'
                    },
                    'provider': {
                        name: 'Fournisseur',
                        db_name: 'provider',
                        orderable: false,
                        sortDirection: 1,
                        type: 'text'
                    },
                    'setup_at': {
                        name: 'Installé le',
                        db_name: 'setup_at',
                        orderable: true,
                        sortDirection: 1,
                        type: 'data'
                    },
                    'setup_by': {
                        name: 'Installé par',
                        db_name: '',
                        orderable: false,
                        sortDirection: 1,
                        type: ''
                    },
                    'withdraw_at': {
                        name: 'Retiré le',
                        db_name: 'setup_at',
                        orderable: true,
                        sortDirection: 1,
                        type: 'data'
                    },
                    'withdraw_by': {
                        name: 'Retiré par',
                        db_name: '',
                        orderable: false,
                        sortDirection: 1,
                        type: ''
                    }
                },
            }
        },
        computed: {
            filteredResults: function () {
                var data = this.data;
                if (this.sortCell) {
                    var cell = this.columns[this.sortCell];
                    var direction = cell['sortDirection'];
                    if (cell['type'] === 'date') {
                        data = data.slice().sort(function (a, b) {
                            var a1 = new Date(a[cell['db_name']]);
                            var b1 = new Date(b[cell['db_name']]);

                            return (a1.getTime() === b1.getTime()) ? 0 : ((a1.getTime() > b1.getTime()) ? 1 : -1) * cell['sortDirection'];
                        });
                    } else if (cell['type'] === 'number') {
                        data = data.slice().sort(function (a, b) {
                            var a1 = a[cell['db_name']];
                            var b1 = b[cell['db_name']];

                            return (a1 === b1) ? 0 : ((a1 > b1) ? 1 : -1) * cell['sortDirection'];
                        });
                    } else if (cell['type'] === 'text') {
                        data = data.slice().sort(function (a, b) {
                            var a1 = a[cell['db_name']];
                            var b1 = b[cell['db_name']];

                            return (a1 === b1) ? 0 : ((a1 > b1) ? 1 : -1) * cell['sortDirection'];
                        });
                    }
                }
                return data;
            },
        },
        created: function () {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed: function () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        mounted: function () {
            this.search();
        },
        methods: {
            export_csv: function () {
                axios
                    .post('export', {
                        equipment_id: this.equipment_id,
                    })
                    .then(response => {
                        if (response.data == 'false') {
                            alert('Une erreur est survenue lors de la génération du fichier CSV. Veuillez réessayer');
                        } else {
                            window.open('/' + response.data);
                        }
                    });

            },
            openDetails: function (entry) {
                this.batch_selected = entry;
            },
            updateBatch: function (entry, take = false) {
                this.loading = true;
                var d = null;
                if (take) {
                    d = this.date_t;
                }
                axios
                    .post('update', {
                        batch_id: entry.id,
                        date: d
                    })
                    .then(response => {
                        if (response.data.status !== 'success') {
                            alert('Une erreur est survenue. Veuillez réessayer.');
                        }
                        this.search();
                    });
            },
            handleScroll: function () {
                if (!this.loading) {
                    if (document.getElementById('loadMore') != null && this.isInViewport(document.getElementById('loadMore'))) {
                        this.loadMore();
                    }
                }
            },
            isInViewport: function (elem) {
                var bounding = elem.getBoundingClientRect();
                return (
                    bounding.top >= 0 &&
                    bounding.left >= 0 &&
                    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            },
            sortBy: function (index) {
                if (this.columns[index]['orderable'] === true) {
                    this.sortCell = index;
                    this.columns[index]['sortDirection'] *= -1;
                }
            },
            loadMore: function () {
                this.page++;
                this.search(true);
            },
            search: function (next_page = false) {
                this.loading = true;
                if (!next_page) {
                    this.page = 1;
                    this.data = [];
                }
                axios
                    .post('search', {
                        query: this.query,
                        start_date: this.start_date,
                        end_date: this.end_date,
                        equipment_id: this.equipment_id,
                        page: this.page,
                    })
                    .then(response => {
                        if (next_page) {
                            this.data = this.data.concat(response.data.data);
                        } else {
                            this.data = response.data.data;
                        }
                        this.response = response.data;
                        this.loading = false;
                    });

            },
        }
    }
</script>
